var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.282,
    height: 84.465,
    viewBox: "0 0 65.282 84.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_273",
    "data-name": "\\u8DEF\\u5F84 273",
    d: "M-1.318,128.117H-6.25v-6.174a20.669,20.669,0,0,0-20.663-20.636,20.65,20.65,0,0,0-20.626,20.636v6.174h-4.949a7.054,7.054,0,0,0-7.021,7.029v43.526a7.058,7.058,0,0,0,7.021,7.1h51.17a7.084,7.084,0,0,0,7.091-7.1V135.146A7.08,7.08,0,0,0-1.318,128.117Zm-36.9-6.174a11.317,11.317,0,0,1,11.3-11.3,11.321,11.321,0,0,1,11.322,11.3v6.174H-38.216Zm15.138,38.064v10.251a.78.78,0,0,1-.793.756H-28.8a.757.757,0,0,1-.738-.756V160.007a9.02,9.02,0,0,1-5.778-8.415,9,9,0,0,1,9-9,9.208,9.208,0,0,1,5.875,2.177,8.808,8.808,0,0,1,3.143,6.822A9.017,9.017,0,0,1-23.078,160.007Z",
    transform: "translate(59.509 -101.307)",
    fill: "#b8b8b8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwIcon);
export default __webpack_public_path__ + "static/media/pw_icon.3d1114f5c878a313732a5de468759166.svg";
export { ForwardRef as ReactComponent };